// --------------------------------------------------------------------------
// enableVisitorSelect.js
// --------------------------------------------------------------------------
// Enable visitor fields when users has selected a ticket type
// --------------------------------------------------------------------------

RN.enableVisitorSelect = function() {

  'use strict';

  var ticketTypes = byElement('ticket-types-visitors');

  function init() {
    var ticketSelect = byBehaviour('enable-visitor-select'),
        radios = ticketSelect.find('input'),
        checked;

    radios.each(function(){
        if(this.checked){
            checked = true;
            return false;
        }
    });

    if(checked){
        enableVisitorSelect();
    }
    else{
        ticketSelect.on('change', enableVisitorSelect);
    }
  }

  function enableVisitorSelect() {
    ticketTypes.removeClass('buy-tickets-ticket-types__people--is-disabled');
    
    $('html, body').stop().animate({
        scrollTop: ticketTypes.offset().top + 'px'
      }, 500);
  }

  return {
    init: init
  };

}();